import { combineReducers } from "redux-immutable";
import upload from "./upload/reducer";
import annotate from "./annotate/reducer";
import download from "./download/reducer";
import status from "./status/reducer";

const ctdReducer = combineReducers({
  upload,
  annotate,
  download,
  status
});

export default ctdReducer;
